import { getAnalytics } from '../../common/analytics';

export const calculatedSavings = (
  calculatorFormData,
  SavingsAmount,
  isPageLoad
) => {
  const properties = {
    pricePerPack: calculatorFormData.price_per_pack,
    cigarettesDaily: calculatorFormData.cigarettes_per_day,
    SavingsAmount,
  };
  if (isPageLoad) {
    getAnalytics().track('Calculator Stats Returned', properties);
  } else {
    getAnalytics().track('Calculator Stats Saved', properties);
  }
};
